(function () {
  'use strict';

  // Set this to your deployed Cloudflare Worker URL
  var WORKER_URL = 'https://agent-m.adelyn.workers.dev';

  // ── State ──────────────────────────────────────────────────────────────────

  var overlay, modal, closeBtn, minimizeBtn, intro, disclaimer, messagesEl, input, sendBtn;
  var messages    = [];
  var isStreaming = false;
  var hasStarted  = false;
  var triggerEl   = null;

  // ── Session persistence ────────────────────────────────────────────────────

  var SESSION_KEY = 'agent_m_session';

  function saveSession() {
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(messages));
    } catch (_) {}
  }

  function loadSession() {
    try {
      var stored = sessionStorage.getItem(SESSION_KEY);
      if (stored) {
        var parsed = JSON.parse(stored);
        if (Array.isArray(parsed) && parsed.length > 0) {
          messages = parsed;
          hasStarted = true;
        }
      }
    } catch (_) {}
  }

  // ── Session & visitor identity ─────────────────────────────────────────────

  var sessionId   = generateUUID();
  var visitorId   = getOrCreateVisitorId();
  var visitCount  = getAndIncrementVisitCount();
  var pageContext = capturePageContext();

  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
  }

  function getOrCreateVisitorId() {
    try {
      var id = localStorage.getItem('agent_m_visitor_id');
      if (!id) { id = generateUUID(); localStorage.setItem('agent_m_visitor_id', id); }
      return id;
    } catch (_) { return generateUUID(); }
  }

  function getAndIncrementVisitCount() {
    try {
      var count = parseInt(localStorage.getItem('agent_m_visit_count') || '0', 10) + 1;
      localStorage.setItem('agent_m_visit_count', String(count));
      return count;
    } catch (_) { return 1; }
  }

  function capturePageContext() {
    var params = new URLSearchParams(window.location.search);
    return {
      referrer:     document.referrer || null,
      utm_source:   params.get('utm_source')   || null,
      utm_medium:   params.get('utm_medium')   || null,
      utm_campaign: params.get('utm_campaign') || null,
    };
  }

  // ── Logging ────────────────────────────────────────────────────────────────

  function logConversation(extra) {
    if (!hasStarted) return;
    var payload = Object.assign({
      session_id:     sessionId,
      visitor_id:     visitorId,
      visit_count:    visitCount,
      messages:       messages,
      first_question: messages.length > 0 ? messages[0].content : null,
      referrer:       pageContext.referrer,
      utm_source:     pageContext.utm_source,
      utm_medium:     pageContext.utm_medium,
      utm_campaign:   pageContext.utm_campaign,
    }, extra || {});

    fetch(WORKER_URL + '/log', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }).catch(function () {});
  }

  function logConversion(type) {
    logConversation({ converted: true, conversion_type: type });
  }

  // ── Conversion tracking ────────────────────────────────────────────────────

  function initConversionTracking() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (form && form.action && form.action.indexOf('/cart/add') !== -1) {
        logConversion('add_to_cart');
      }
    }, true);

    document.addEventListener('click', function (e) {
      var el = e.target.closest('[data-add-to-cart], [name="add"], .product-form__submit');
      if (el) logConversion('add_to_cart');
    }, true);

    document.addEventListener('click', function (e) {
      var el = e.target.closest('a');
      if (el && el.href && el.href.indexOf('/checkout') !== -1) {
        logConversion('checkout_started');
      }
    }, true);
  }

  // ── Modal open / close ─────────────────────────────────────────────────────

  function init() {
    overlay    = document.getElementById('agent-m-overlay');
    if (!overlay) return;

    modal      = document.getElementById('agent-m-modal');
    closeBtn   = document.getElementById('agent-m-close');
    minimizeBtn= document.getElementById('agent-m-minimize');
    intro      = document.getElementById('agent-m-intro');
    disclaimer = document.getElementById('agent-m-disclaimer');
    messagesEl = document.getElementById('agent-m-messages');
    input      = document.getElementById('agent-m-input');
    sendBtn    = document.getElementById('agent-m-send');

    // Nav trigger — toggles open/close, tracks active state
    document.querySelectorAll('[data-agent-m-trigger]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (overlay.classList.contains('is-open')) {
          closeModal();
        } else {
          triggerEl = el;
          openModal();
        }
      });
    });

    // Chip click — send the chip's prompt
    document.querySelectorAll('.agent-m-chip').forEach(function (chip) {
      chip.addEventListener('click', function () {
        var prompt = chip.getAttribute('data-prompt');
        if (prompt) sendMessage(prompt);
      });
    });

    closeBtn.addEventListener('click', closeModal);
    if (minimizeBtn) minimizeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', handleKeydown);
    sendBtn.addEventListener('click', handleSend);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSend(); }
    });

    initConversionTracking();

    // Restore previous session if any
    loadSession();
    if (hasStarted) {
      intro.setAttribute('hidden', '');
      if (disclaimer) disclaimer.setAttribute('hidden', '');
      renderMessages();
    }
  }

  function openModal() {
    if (triggerEl) triggerEl.classList.add('is-active');
    overlay.removeAttribute('hidden');
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    input.focus();
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    if (triggerEl) triggerEl.classList.remove('is-active');
    setTimeout(function () { overlay.setAttribute('hidden', ''); }, 220);
    if (triggerEl) triggerEl.focus();
  }

  function handleKeydown(e) {
    if (!overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeModal(); return; }
    if (e.key === 'Tab') handleTabTrap(e);
  }

  function handleTabTrap(e) {
    var focusable = Array.from(
      modal.querySelectorAll('button:not([disabled]), input:not([disabled])')
    );
    if (!focusable.length) return;
    var first = focusable[0], last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // ── Chat ───────────────────────────────────────────────────────────────────

  function handleSend() {
    var text = input.value.trim();
    if (!text || isStreaming) return;
    input.value = '';
    sendMessage(text);
  }

  function sendMessage(text) {
    if (!hasStarted) {
      hasStarted = true;
      intro.setAttribute('hidden', '');
      if (disclaimer) disclaimer.setAttribute('hidden', '');
    }

    messages.push({ role: 'user', content: text });
    messages.push({ role: 'assistant', content: '' });
    renderMessages();
    streamResponse();
  }

  function streamResponse() {
    isStreaming = true;
    sendBtn.disabled = true;
    input.disabled = true;

    var lastIdx = messages.length - 1;
    var accText = '';
    var requestMessages = messages.slice(0, lastIdx);

    // Show typing dots immediately while waiting for first token
    updateLastBubble('', true);

    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ messages: requestMessages }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Request failed: ' + res.status);
        return readSSEStream(res, function (chunk) {
          try {
            var event = JSON.parse(chunk);
            if (
              event.type === 'content_block_delta' &&
              event.delta && event.delta.type === 'text_delta'
            ) {
              accText += event.delta.text;
              messages[lastIdx].content = accText;
              updateLastBubble(accText, true);
            }
          } catch (_) {}
        });
      })
      .catch(function () {
        messages[lastIdx].content = 'Something went wrong. Please try again.';
        updateLastBubble(messages[lastIdx].content);
      })
      .finally(function () {
        isStreaming = false;
        sendBtn.disabled = false;
        input.disabled = false;
        // Strip cursor from final bubble now that streaming is done
        updateLastBubble(messages[lastIdx].content, false);
        input.focus();
        saveSession();
        logConversation();
      });
  }

  function readSSEStream(response, onChunk) {
    var reader = response.body.getReader();
    var decoder = new TextDecoder();
    var buffer = '';

    function pump() {
      return reader.read().then(function (result) {
        if (result.done) return;
        buffer += decoder.decode(result.value, { stream: true });
        var lines = buffer.split('\n');
        buffer = lines.pop();
        lines.forEach(function (line) {
          if (line.indexOf('data: ') === 0) {
            var data = line.slice(6).trim();
            if (data && data !== '[DONE]') onChunk(data);
          }
        });
        return pump();
      });
    }

    return pump().finally(function () { reader.releaseLock(); });
  }

  // ── Render ─────────────────────────────────────────────────────────────────

  function renderMessages() {
    messagesEl.innerHTML = '';
    messages.forEach(function (msg) { messagesEl.appendChild(createMessageEl(msg)); });
    scrollToBottom();
  }

  function createMessageEl(msg) {
    var outer = document.createElement('div');
    outer.className = 'agent-m-message agent-m-message--' + msg.role;
    var bubble = document.createElement('div');
    bubble.className = 'agent-m-bubble';
    bubble.innerHTML = renderText(msg.content);
    outer.appendChild(bubble);
    return outer;
  }

  function updateLastBubble(text, withCursor) {
    var bubbles = messagesEl.querySelectorAll('.agent-m-bubble');
    if (bubbles.length) {
      bubbles[bubbles.length - 1].innerHTML = renderText(text, withCursor);
      scrollToBottom();
    }
  }

  function renderText(text, withCursor) {
    // Typing dots while waiting for first token
    if (!text) return '<div class="agent-m-typing"><span></span><span></span><span></span></div>';

    var escaped = text
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    escaped = escaped.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    var cursor = withCursor ? '<span class="agent-m-cursor"></span>' : '';

    // Double newline → paragraph break
    var paragraphs = escaped.split(/\n\n+/);
    if (paragraphs.length > 1) {
      var html = paragraphs.map(function (p) {
        return '<p>' + renderLines(p) + '</p>';
      }).join('');
      return html + cursor;
    }

    return renderLines(escaped) + cursor;
  }

  function renderLines(text) {
    var lines = text.split('\n'), result = [], inList = false;
    lines.forEach(function (line) {
      if (/^- (.+)/.test(line)) {
        if (!inList) { result.push('<ul>'); inList = true; }
        result.push('<li>' + line.slice(2) + '</li>');
      } else {
        if (inList) { result.push('</ul>'); inList = false; }
        result.push(line);
      }
    });
    if (inList) result.push('</ul>');
    return result.join('<br>').replace(/<br>(<\/?[uo]l>)/g, '$1');
  }

  function scrollToBottom() { messagesEl.scrollTop = messagesEl.scrollHeight; }

  // ── Boot ───────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
